import { render, staticRenderFns } from "./patterns.vue?vue&type=template&id=5c43f705&scoped=true&"
import script from "./patterns.vue?vue&type=script&lang=js&"
export * from "./patterns.vue?vue&type=script&lang=js&"
import style0 from "./patterns.vue?vue&type=style&index=0&id=5c43f705&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c43f705",
  null
  
)

export default component.exports